'use client'

import { SessionProvider } from 'next-auth/react'
import { ToastProvider } from '@/components/ui/toast'
import { CommandPalette } from '@/components/CommandPalette'
import { AIProvider } from '@/context/AIContext'
import { CommandPaletteProvider } from '@/context/CommandPaletteContext'
import { AIManager } from '@/components/ai/AIManager'
import { BrandingProvider } from '@/context/BrandingContext'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider
      basePath={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/api/auth`}
      refetchInterval={4 * 60}
      refetchOnWindowFocus={true}
    >
      <BrandingProvider>
        <CommandPaletteProvider>
          <AIProvider>
            {children}
            <ToastProvider />
            <CommandPalette />
            <AIManager />
          </AIProvider>
        </CommandPaletteProvider>
      </BrandingProvider>
    </SessionProvider>
  )
}
